export enum VIPJobName {
  CONVERT_WISHLIST_TO_ORDER = 'VIPJobName:CONVERT_WISHLIST_TO_ORDER'
}
